<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [canGoBack]="true"
      [title]="'Published Workflow'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>


    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }

    @if (loaded) {
      @if (!publishedVersionIsLatestVersion) {
        <tidy-row>
          <tidy-text
            [body]="'You have a newer unpublished version.'" /><span>&nbsp;</span>
            <tidy-text
              [body]="'View'"
              class="white-link"
              (action)="goToEditWorkflow()" />
          </tidy-row>
        }
        <tidy-card>
          <tidy-row [alignLastItemRight]="true">
            <tidy-row class="full-width">
              <tidy-image
                [src]="'assets/img/workflow-diagram.svg'"
                class="title-size" />
              <tidy-text
                [header]="workflowForm.get('name').value"
                class="workflow-name" />
            </tidy-row>
            <tidy-toggle
              [toggled]="!workflow.paused_at"
              (toggleChanged)="pauseUnpauseWorkflow(workflow)" />
          </tidy-row>
          <tidy-card-button (click)="goToEditWorkflow()">
            <tidy-row class="vertical-align-center">
              <tidy-text
                [body]="'Edit Workflow'" />
            </tidy-row>
          </tidy-card-button>
          <tidy-card-button (click)="deleteWorkflow()">
            <tidy-row class="vertical-align-center">
              <tidy-text
                [body]="'Delete Workflow'" />
            </tidy-row>
          </tidy-card-button>
        </tidy-card>
        <tidy-card>
          <tidy-row class="extra-bottom-padding vertical-align-center">
            <tidy-image
              [src]="'assets/img/play.svg'"
              class="title-size" />
            <tidy-text
              [header]="'Trigger'" />
          </tidy-row>
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="selectedTrigger.icon_url"
              class="title-size" />
            <tidy-text
              [body]="selectedTrigger.name" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="selectedTrigger.description" />
          </tidy-row>
          @if (selectedTrigger?.inputs?.length) {
            @for (input of selectedTrigger?.inputs; track input) {
              @if (input.key === 'token' && input?.displayValue) {
                <tidy-row class="webhook-url-display">
                  <div class="webhook-url-container">
                    <span class="webhook-url-text">{{ webhookUrl }}{{ input?.displayValue }}</span>
                    <mat-icon
                      class="copy-icon-small"
                      (click)="copyWebhook(input?.displayValue)">
                      content_copy
                    </mat-icon>
                  </div>
                </tidy-row>
              } @else {
                <tidy-row class="extra-top-padding">
                  <tidy-text
                    [body]="'<b>' + getFilterNameInSingular(input.form.label) + (' Filter:</b>' | translate)" />
                </tidy-row>
                <tidy-row>
                  <tidy-text
                    [body]="input?.displayValue" />
                </tidy-row>
              }
            }
          }
        </tidy-card>
        @if (selectedTrigger) {
          @for (action of selectedActions; track action; let actionIndex = $index) {
            <tidy-card>
              <tidy-row class="extra-bottom-padding vertical-align-center">
                <tidy-image
                  [src]="'assets/img/check.svg'"
                  class="title-size" />
                <tidy-text
                  [header]="'Action'" /><span>&nbsp;</span>
                  <tidy-text
                    [header]="((actionIndex | translate) + (1 | translate))" />
                </tidy-row>
                <tidy-row class="vertical-align-center">
                  <tidy-image
                    [src]="action.icon_url"
                    class="body-size" />
                  <tidy-text
                    [body]="action.name" />
                </tidy-row>
                <tidy-row>
                  <tidy-text
                    [body]="action.description" />
                </tidy-row>
                @for (input of action?.inputs; track input) {
                  @if (!hideInput(action, input)) {
                    <tidy-row class="extra-top-padding">
                      <tidy-text [body]="'<b>' + input.form.label + '</b>'" /><br />
                      @if (input.form.type === 'filter') {
                        @for (filter of action?.filterInputs; track filter; let filterIndex = $index) {
                          <ion-row style="padding: 1rem 0px; padding-bottom: 0.5rem;">
                            <ion-col size="12" style="padding: 0px;">
                              @if (filterIndex === 0) {
                                <div style="padding-top: 1rem;">
                                  <tidy-text [body]="'<b>Only continue if</b>'" />
                                </div>
                              }
                              @if (filterIndex > 0) {
                                <tidy-text [body]="'<b>Or continue if</b>'" />
                              }
                              @for (filterItem of filter; track filterItem; let filterItemIndex = $index) {
                                <ion-row>
                                  <ion-col size="12" style="padding-right: 0px; padding-left: 0px;">
                                    @if (filterItemIndex > 0) {
                                      <tidy-text [body]="'<b>And</b>'" />
                                    }
                                  </ion-col>
                                </ion-row>
                                <ion-row>
                                  <ion-col size="12" style="padding-left: 0px; padding-right: 0px;">
                                    @if (filterItem?.left_value) {
                                      <tidy-text
                                        [body]="filterItem?.left_value + ' '" />
                                    }
                                    @if (filterItem?.operator) {
                                      <tidy-text
                                        [body]="filterItem?.operator + ' '" />
                                    }
                                    @if (filterItem?.right_value) {
                                      <tidy-text
                                        [body]="filterItem?.right_value + ' '" />
                                    }
                                    @if (filterItem?.timezone) {
                                      <tidy-text
                                        [body]="filterItem?.timezone" />
                                    }
                                  </ion-col>
                                </ion-row>
                              }
                            </ion-col>
                          </ion-row>
                        }
                      }
                      @if (input.form.type !== 'filter') {
                        @if (input.form.type !== 'files') {
                          <tidy-chip-text-area
                            [id]="getActionForm(actionIndex).get('formId').value"
                            [inputKey]="input.key"
                            [readonly]="true" />
                        } @else {
                          @if (action?.input_values?.attachments?.length > 0) {
                            <ion-row>
                              @for (attachment of action?.input_values?.attachments; track attachment; let i = $index) {
                                <ion-col size="12" sizeMd="6" sizeLg="4" sizeXl="3">
                                  <div
                                    style="width: 100%"
                                    class="image-preview">
                                    <img [src]="attachment" />
                                  </div>
                                </ion-col>
                              }
                            </ion-row>
                          }
                        }
                      }
                    </tidy-row>
                  }
                }
              </tidy-card>
            }
          }
        }

      </tidy-wrapper>
    </ng-template>

    @if (!isRightSideContent) {
      <app-scroll-wrapper [templateContent]="content" />
    }

    @if (isRightSideContent) {
      <ion-content class="ion-content-right-column">
        <ng-container *ngTemplateOutlet="content" />
      </ion-content>
    }
